module.exports = __webpack_public_path__ + "static/media/asset02.123ece76.jpg";